export const version = "ethers/5.1.0";
//# sourceMappingURL=_version.js.map